// removed by extract-text-webpack-plugin
module.exports = {"small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","summary":"summary-1lsRB","summaryItem":"summaryItem-3MHb2","summaryAmount":"summaryAmount-1rhmd","summaryTag":"summaryTag-wqxaV","summaryTitle":"summaryTitle-1JUw1","lifetimeStatsIconContainer":"lifetimeStatsIconContainer-2jkpj","lifetimeStatsIcon":"lifetimeStatsIcon-Zm_6v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/workouts/dashboard/lifetime/_statsSummary.css
// module id = 1288
// module chunks = 1